export const STATUS_CODE_OK = 200;

export const STATUS_CODE_BAD_REQUEST = 400;

// Special custom 5xx HTTP status code to mean that the UDF returned an error.
//
// Must match constant of the same name in Rust.
export const STATUS_CODE_UDF_FAILED = 560;
